import React from 'react';
import { SparklesIcon, WrenchIcon, ChevronRightIcon, UsersIcon, AlertTriangleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buttonClasses } from './ui/Button';
import { Card, CardHeader, CardContent } from './ui/Card';
export function SuggerimentiSection() {
  return <div className="mb-8" data-id="element-1122">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-1123">
        Suggerimenti
      </h2>
      <div className="flex flex-col gap-4" data-id="element-1124">
        {/* Card 1: Ottimizzazione pulizie */}
        <Card data-id="element-1125">
          <CardHeader icon={<SparklesIcon size={15} className="text-foreground" data-id="element-1127" />} title="Ottimizza le pulizie" subtitle="Condividi il servizio con host in zona" action={<Link to="/pianificazione" className={buttonClasses({
          variant: 'outline',
          size: 'sm'
        })} data-id="element-1128">
                Vedi
                <ChevronRightIcon size={14} data-id="element-1129" />
              </Link>} data-id="element-1126" />
          <CardContent data-id="element-1130">
            <div className="grid grid-cols-2 gap-3" data-id="element-1131">
              <div className="bg-white border border-border rounded-lg p-3 flex flex-col items-center text-center" data-id="element-1132">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-1133">
                  <UsersIcon size={13} className="text-muted-foreground" data-id="element-1134" />
                  <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1135">
                    Condivisibili
                  </span>
                </div>
                <span className="text-2xl font-bold text-foreground leading-none" data-id="element-1136">
                  3
                </span>
                <span className="text-[10px] text-muted-foreground mt-0.5" data-id="element-1137">
                  pulizie
                </span>
              </div>
              <div className="bg-white border border-border rounded-lg p-3 flex flex-col items-center text-center" data-id="element-1138">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-1139">
                  <SparklesIcon size={13} className="text-muted-foreground" data-id="element-1140" />
                  <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1141">
                    Risparmio
                  </span>
                </div>
                <span className="text-2xl font-bold text-coral leading-none" data-id="element-1142">
                  €42
                </span>
                <span className="text-[10px] text-muted-foreground mt-0.5" data-id="element-1143">
                  stimato
                </span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Card 2: Tecnici in zona */}
        <Card data-id="element-1144">
          <CardHeader icon={<WrenchIcon size={15} className="text-foreground" data-id="element-1146" />} title="Risolvi le segnalazioni" subtitle="Tecnici disponibili la prossima settimana" action={<Link to="/segnalazioni" className={buttonClasses({
          variant: 'outline',
          size: 'sm'
        })} data-id="element-1147">
                Vedi
                <ChevronRightIcon size={14} data-id="element-1148" />
              </Link>} data-id="element-1145" />
          <CardContent data-id="element-1149">
            <div className="grid grid-cols-2 gap-3" data-id="element-1150">
              <div className="bg-white border border-border rounded-lg p-3 flex flex-col items-center text-center" data-id="element-1151">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-1152">
                  <AlertTriangleIcon size={13} className="text-muted-foreground" data-id="element-1153" />
                  <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1154">
                    Aperte
                  </span>
                </div>
                <span className="text-2xl font-bold text-foreground leading-none" data-id="element-1155">
                  3
                </span>
                <span className="text-[10px] text-muted-foreground mt-0.5" data-id="element-1156">
                  segnalazioni
                </span>
              </div>
              <div className="bg-white border border-border rounded-lg p-3 flex flex-col items-center text-center" data-id="element-1157">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-1158">
                  <WrenchIcon size={13} className="text-muted-foreground" data-id="element-1159" />
                  <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1160">
                    In zona
                  </span>
                </div>
                <span className="text-2xl font-bold text-coral leading-none" data-id="element-1161">
                  4
                </span>
                <span className="text-[10px] text-muted-foreground mt-0.5" data-id="element-1162">
                  tecnici
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}